import { apiClient, type DcEntity } from '@/libs/api'

export type FetchDcQuery = {
  tenantKey: string
  dcId: number
}

export const fetchDc = async (
  { tenantKey, dcId }: FetchDcQuery,
  signal?: AbortSignal
): Promise<DcEntity> => {
  const { data } = await apiClient._tenant(tenantKey).dcs._id(dcId).$get({
    config: {
      signal
    }
  })
  return data
}
